<div class="container-fluid mt-2 overview-page" [class.is-fullscreen]="isFullscreen">

  <!-- Toolbar -->
  <div class="toolbar">
    <div class="toolbar-filters">
      <div class="toolbar-filter-item toolbar-search">
        <div class="input-group input-group-sm">
          <span class="input-group-text">
            <i class="fas fa-search text-muted"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Search location..."
            [(ngModel)]="search"
            name="search"
            (ngModelChange)="onSearch()">
        </div>
      </div>
      <div class="form-check form-switch m-0 toolbar-filter-item">
        <input class="form-check-input" type="checkbox" role="switch"
               id="convertedUnits"
               [(ngModel)]="isConvertedUnits"
               [ngModelOptions]="{standalone: true}"
               (ngModelChange)="onConvertedUnits($event)">
        <label class="form-check-label" for="convertedUnits">Conversion</label>
      </div>
      <span class="toolbar-stat" *ngIf="baseCurrency.code">
        <span class="toolbar-stat-key">{{baseCurrency.code}} / {{baseUnit.code}}</span>
        <span class="toolbar-stat-divider">·</span>
        <span class="toolbar-stat-value">{{ totalRows || 0 }} {{ (totalRows || 0) === 1 ? 'offer' : 'offers' }}</span>
      </span>
    </div>
    <div class="toolbar-actions">
      <jft-revision-conversion-params-modal
        *ngIf="user.canManageAdvanced(tender)"
        [currencies]="currencies"
        [customUnits]="customUnits"
        [conversionFactor]="conversionFactor"
        [tender]="tender"
        [previousTender]="previousTender"
        [baseCurrency]="baseCurrency"
        [baseUnit]="baseUnit"
        [includedIndex]="includedIndex"
        [includedMarket]="includedMarket"
        (onIncludedIndex)="onIncludedIndex($event)"
        (onIncludedMarket)="onIncludedMarket($event)"
        (onSetUnitsDefault)="setUnitsDefault($event)"
        (onSetCustomUnit)="onCustomUnit($event)"
        (onUpdateExchangeRates)="updateExchangeRates($event)"
        (onSetCustomCurrency)="onCustomCurrency($event)"
        (onBaseCurrencyChange)="baseCurrencyChange($event)"
        (onBaseUnitChange)="baseUnitChange($event)">
      </jft-revision-conversion-params-modal>
      <jft-revision-view-settings-modal
        [columnHeaders]="headers"
        [columnHidden]="hiddenHeaders"
        [columnOrdered]="orderedHeadersArray"
        [columnFrozen]="frozenColumns"
        (onSaveHidden)="onSaveHidden($event)"
        (onSaveSorted)="onSaveSorted($event)"
        (onSaveFrozen)="onSaveFrozen($event)">
      </jft-revision-view-settings-modal>
      <button type="button"
              class="btn btn-sm btn-link text-decoration-none p-0 px-2 fullscreen-toggle"
              (click)="toggleFullscreen()"
              [ngbTooltip]="isFullscreen ? 'Exit fullscreen (Esc)' : 'Fullscreen'"
              placement="bottom-end">
        <svg *ngIf="!isFullscreen" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M3 7V5a2 2 0 0 1 2-2h2"/>
          <path d="M17 3h2a2 2 0 0 1 2 2v2"/>
          <path d="M21 17v2a2 2 0 0 1-2 2h-2"/>
          <path d="M7 21H5a2 2 0 0 1-2-2v-2"/>
        </svg>
        <svg *ngIf="isFullscreen" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
             viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
             stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M9 3v4a2 2 0 0 1-2 2H3"/>
          <path d="M15 3v4a2 2 0 0 0 2 2h4"/>
          <path d="M15 21v-4a2 2 0 0 1 2-2h4"/>
          <path d="M9 21v-4a2 2 0 0 0-2-2H3"/>
        </svg>
        <span class="ms-1 d-none d-md-inline">{{ isFullscreen ? 'Exit Fullscreen' : 'Fullscreen' }}</span>
      </button>
    </div>
  </div>

  <!-- Summary chips (always visible — show baseline when no model is
       selected, switch to awarded values when bids are ticked) -->
  <div class="overview-summary-bar" *ngIf="!loading && offers.length">
    <div class="overview-summary-cell"
         [ngbTooltip]="hasSelectedBids ? 'Sum of selected awards (volume × award %)' : 'Total tender volume across all locations'"
         placement="bottom">
      <div class="overview-summary-value">
        {{ (hasSelectedBids ? selectedTotalVolume : totalVolume) | number: '1.0-0' }} {{baseUnit.code}}
      </div>
      <div class="overview-summary-label">
        {{ hasSelectedBids ? 'Awarded Volume' : 'Total Volume' }}
      </div>
    </div>
    <div class="overview-summary-cell"
         [ngbTooltip]="hasSelectedBids ? 'Projected spend across selected awards' : 'Baseline spend on current contracts'"
         placement="bottom">
      <div class="overview-summary-value">
        {{ (hasSelectedBids ? selectedContractsTotal : currentContractsTotal) | number: '1.0-0' }} {{baseCurrency.code}}
      </div>
      <div class="overview-summary-label">
        {{ hasSelectedBids ? 'Awarded Total' : 'Contract Total' }}
      </div>
    </div>
    <div class="overview-summary-cell">
      <div class="overview-summary-value">
        {{ finalGap | number: '1.0-2' }} {{baseCurrency.code}} / {{baseUnit.code}}
      </div>
      <div class="overview-summary-label">Per {{baseUnit.code}} Gap</div>
    </div>
    <div class="overview-summary-cell">
      <div class="overview-summary-value">
        {{ finalGapTotal | number: '1.0-0' }} {{baseCurrency.code}}
      </div>
      <div class="overview-summary-label">Total Gap</div>
    </div>
  </div>

  <!-- Tabs (model tabs strip) -->
  <div class="tabs-card">
    <jft-revision-tab-models
      (onChanged)="onChangedModelTabs($event)"
      (onSelectedTab)="onSelectedModelTab($event)"
      [baseCurrencyCode]="baseCurrency.code"
      [baseUnitCode]="baseUnit.code"
      [finalBaseAmount]="finalBaseAmount"
      [finalGap]="finalGap"
      [finalGapTotal]="finalGapTotal"
      [currentContractsTotal]="currentContractsTotal"
      [totalVolume]="totalVolume"
      [selectedContractsTotal]="selectedContractsTotal"
      [selectedTotalVolume]="selectedTotalVolume"
      [hasSelectedBids]="hasSelectedBids"
      [canManage]="user.canManage(tender)"
      [tenderId]="tender.id">
    </jft-revision-tab-models>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="d-flex justify-content-center p-5">
    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <!-- Empty state -->
  <div class="alert alert-warning py-2 px-3 mb-2 small d-flex align-items-center" *ngIf="!offers.length && !loading">
    <i class="fas fa-triangle-exclamation text-danger me-2"></i>
    <span>No bids have been submitted for this tender, or current contract information is not available. Awaiting bids or current-contract import.</span>
  </div>

  <!-- Table -->
  <div *ngIf="!loading && offers.length && table" class="table-card">
    <div class="table-wrapper custom-scrollbar">
      <table class="revision-table">
        <thead>
          <tr>
            <th *ngFor="let header of table.getHeaderGroups()[0].headers"
                [class.is-frozen]="isFrozen(header.column.id)"
                [class.is-sortable]="header.column.getCanSort()"
                [style.left.px]="isFrozen(header.column.id) ? getFrozenLeft(header.column.id) : null"
                [style.min-width.px]="getColumnWidth(header.column.id)"
                [style.width.px]="getColumnWidth(header.column.id)"
                (click)="header.column.getCanSort() && header.column.toggleSorting()">
              <div class="th-content">
                <span class="th-label" *ngIf="header.column.id !== 'index_market_value'">
                  {{ header.column.columnDef.header }}
                </span>
                <span class="th-label" *ngIf="header.column.id === 'index_market_value'">
                  <ng-template #popContent>
                    <jft-index-date-range
                      [dateRange]="indexDateRange"
                      [placeholder]="'Date Range'"
                      [class]="'form-control form-control-sm mb-0'"
                      (onDates)="onDateRange($event)">
                    </jft-index-date-range>
                  </ng-template>
                  <ng-template #popTitle>Select Averaging Period</ng-template>
                  <button type="button"
                          class="btn btn-link btn-sm p-0 m-0 text-decoration-none align-baseline"
                          [ngbPopover]="popContent"
                          [popoverTitle]="popTitle"
                          [autoClose]="'outside'"
                          placement="bottom"
                          (click)="$event.stopPropagation()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6"/>
                      <path d="m12 12 4 10 1.7-4.3L22 16Z"/>
                    </svg>
                    <span class="ms-1">{{ header.column.columnDef.header }}</span>
                  </button>
                </span>
                <span class="sort-indicator" *ngIf="header.column.getCanSort()">
                  <i class="fas fa-sort-up" *ngIf="header.column.getIsSorted() === 'asc'"></i>
                  <i class="fas fa-sort-down" *ngIf="header.column.getIsSorted() === 'desc'"></i>
                  <i class="fas fa-sort text-muted opacity-50" *ngIf="!header.column.getIsSorted()"></i>
                </span>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of table.getRowModel().rows; trackBy: trackOffer"
              [class.is-awarded]="row.original.status === 'AWARDED_CONTRACT'"
              [class.is-new-location]="row.original['new_location']">
            <td *ngFor="let cell of row.getVisibleCells()"
                [class.is-frozen]="isFrozen(cell.column.id)"
                [style.left.px]="isFrozen(cell.column.id) ? getFrozenLeft(cell.column.id) : null"
                [style.min-width.px]="getColumnWidth(cell.column.id)"
                [style.width.px]="getColumnWidth(cell.column.id)"
                [attr.data-col-id]="cell.column.id">
              <ng-container [ngSwitch]="cell.column.id">

                <ng-container *ngSwitchCase="'iata'">
                  <span class="iata-link">{{ row.original.contract.location.iata }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'location_company'">
                  {{ row.original.contract['company_child']
                    ? (row.original.contract['company_child'].alias || row.original.contract['company_child'].name)
                    : row.original.contract['company_info'] }}
                </ng-container>

                <ng-container *ngSwitchCase="'contract_period'">
                  {{ row.original.contract['date_start'] | date: defaultDateFormat : 'utc' }}
                  – {{ row.original.contract['date_end'] | date: defaultDateFormat : 'utc' }}
                </ng-container>

                <ng-container *ngSwitchCase="'yearly_volume'">
                  {{ row.original.contract.volume | number : '1.0-0' | usNumber }}
                  <span class="cell-unit">{{ row.original.contract.units?.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'monthly_volume'">
                  <ng-container *ngIf="row.original.contract['month_service'] && +row.original.contract['month_service'] > 0 && row.original.contract.volume != null">
                    {{ (row.original.contract.volume / +row.original.contract['month_service']) | number : '1.0-0' | usNumber }}
                    <span class="cell-unit">{{ row.original.contract.units?.code }}</span>
                  </ng-container>
                </ng-container>

                <ng-container *ngSwitchCase="'months_of_service'">
                  {{ row.original.contract['month_service'] }}
                </ng-container>

                <ng-container *ngSwitchCase="'fuel_type'">
                  {{ row.original.contract['fuel_type']?.name || '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'flight_type'">
                  {{ row.original.contract['flight_type']?.name || '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'delivery_point'">
                  {{ (row.original.contract['fuel_preference'] || row.original.bid?.fuelPreference)?.name || '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'supplier'">
                  <span class="fw-medium">{{ row.original.supplier.name }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'alias'">
                  {{ row.original.supplier['supplier_alias'] || '–' }}
                </ng-container>

                <ng-container *ngSwitchCase="'round'">
                  <span class="badge bg-light text-dark border" *ngIf="row.original['round']">R{{ row.original['round'] }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'location_ranking'">
                  <span class="badge rank-badge"
                        *ngIf="row.original.bid?.location_ranking"
                        [class.rank-best]="row.original.bid.location_ranking === 1">
                    #{{ row.original.bid.location_ranking }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'offer'">
                  <a [routerLink]="['/tenders', $safeNavigationMigration(row.original.contract.tender?.uid), 'locations', row.original.contract['id'], 'dashboard', 'rounds', row.original['round'], 'suppliers', row.original['id']]"
                     target="_blank"
                     class="offer-link"
                     [title]="(row.original.contract?.tender?.name || '') + ' – ' + (row.original.contract?.fuel_preference?.name || '') + ' / ' + (row.original.contract?.fuel_type?.name || '') + ' / ' + (row.original.contract?.company_info || '')">
                    {{ row.original['name'] }}
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none"
                         stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M21 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h6"/>
                      <path d="m21 3-9 9"/>
                      <path d="M15 3h6v6"/>
                    </svg>
                  </a>
                </ng-container>

                <ng-container *ngSwitchCase="'status'">
                  <span class="badge"
                        [class.bg-success-subtle]="row.original.status === 'AWARDED_CONTRACT'"
                        [class.text-success-emphasis]="row.original.status === 'AWARDED_CONTRACT'"
                        [class.bg-light]="row.original.status !== 'AWARDED_CONTRACT'"
                        [class.text-dark]="row.original.status !== 'AWARDED_CONTRACT'"
                        [class.border]="row.original.status !== 'AWARDED_CONTRACT'">
                    {{ row.original.status === 'AWARDED_CONTRACT' ? 'Contract' : 'Initial Offer' }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'intoplane'">
                  {{ row.original.bid['into_plane'] || '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'all_fees'">
                  <span class="text-muted small">{{ allFeeNames(row.original) }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'fuel_availability'">
                  {{ row.original.bid['fuel_availability_percentage'] }}%
                </ng-container>

                <ng-container *ngSwitchCase="'differential'">
                  <span *ngIf="!isConvertedUnits">{{ row.original.bid?.differential?.price?.value }}</span>
                  <span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_differential'] | number: '1.4-4' }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'diff_currency_units'">
                  <span *ngIf="!isConvertedUnits" class="text-muted small">{{ row.original.bid?.differential?.price?.currency?.code }} / {{ row.original.bid?.differential?.units?.code }}</span>
                  <span *ngIf="isConvertedUnits" class="text-muted small">{{ baseCurrency.code }} / {{ baseUnit.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'base'">
                  {{ (row.original.bid?.index && row.original.bid?.index?.index_code
                      ? tender.company.settings.getFilteredOptionLabel('index', row.original.bid.index.index_code, 'code')
                      : '') | slice:0:12 }}
                  <span *ngIf="row.original.bid['market_price']">Market</span>
                </ng-container>

                <ng-container *ngSwitchCase="'bate'">
                  {{ row.original.bid?.index ? row.original.bid?.index?.bate?.name : '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'averaging_method'">
                  {{ row.original.bid?.index ? row.original.bid?.index?.averaging_method?.name : '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'averaging_offset'">
                  {{ row.original.bid?.index ? row.original.bid?.index?.averaging_offset?.name : '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'update'">
                  {{ row.original.bid?.index ? row.original.bid?.index?.effective_day?.name : '' }}
                </ng-container>

                <ng-container *ngSwitchCase="'index_market_value'">
                  <span *ngIf="row.original.bid?.index">{{ $safeNavigationMigration(row.original.bid?.index?.average_price) | number: '1.4-4' }}</span>
                  <span *ngIf="row.original.bid['market_price']">{{ $safeNavigationMigration(row.original.bid['market_price']?.price?.price?.value) | number: '1.4-4' }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'index_market_unit'">
                  <span class="text-muted small" *ngIf="row.original.bid?.index?.average_price">{{ baseUnit.code }}</span>
                  <span class="text-muted small" *ngIf="row.original.bid['market_price']">{{ row.original.bid['market_price']?.price?.units?.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'index_market_currency'">
                  <span class="text-muted small" *ngIf="row.original.bid?.index?.average_price">{{ baseCurrency.code }}</span>
                  <span class="text-muted small" *ngIf="row.original.bid['market_price']">{{ row.original.bid['market_price']?.price?.price?.currency?.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'per_usage_based_fees'">
                  {{ row.original.bid['per_uplift_fees_total'] | number: '1.0-2' }}
                </ng-container>

                <ng-container *ngSwitchCase="'per_usage_currency'">
                  <span class="text-muted small">{{ baseCurrency.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'av_uplift'">
                  {{ (row.original.contract['average_uplift'] || 0) | number : '1.0' | usNumber }}
                  <span class="text-muted small" *ngIf="row.original.contract['average_uplift']">{{ baseUnit.code }}</span>
                </ng-container>

                <!-- Fee 1..12 -->
                <ng-container *ngSwitchCase="'fee_1'">{{ row.original.bid?.volume_based_fees?.[0]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_1_price'">
                  <ng-container *ngIf="row.original.bid?.volume_based_fees?.length">
                    <span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[0]?.price?.price?.value }}</span>
                    <span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_0'] | number: '1.4-4' }}</span>
                  </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'fee_1_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[0]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[0]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_2'">{{ row.original.bid?.volume_based_fees?.[1]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_2_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 1"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[1]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_1'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_2_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 1"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[1]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[1]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_3'">{{ row.original.bid?.volume_based_fees?.[2]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_3_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 2"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[2]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_2'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_3_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 2"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[2]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[2]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_4'">{{ row.original.bid?.volume_based_fees?.[3]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_4_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 3"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[3]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_3'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_4_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 3"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[3]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[3]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_5'">{{ row.original.bid?.volume_based_fees?.[4]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_5_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 4"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[4]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_4'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_5_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 4"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[4]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[4]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_6'">{{ row.original.bid?.volume_based_fees?.[5]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_6_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 5"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[5]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_5'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_6_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 5"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[5]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[5]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_7'">{{ row.original.bid?.volume_based_fees?.[6]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_7_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 6"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[6]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_6'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_7_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 6"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[6]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[6]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_8'">{{ row.original.bid?.volume_based_fees?.[7]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_8_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 7"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[7]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_7'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_8_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 7"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[7]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[7]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_9'">{{ row.original.bid?.volume_based_fees?.[8]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_9_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 8"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[8]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_8'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_9_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 8"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[8]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[8]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_10'">{{ row.original.bid?.volume_based_fees?.[9]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_10_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 9"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[9]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_9'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_10_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 9"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[9]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[9]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_11'">{{ row.original.bid?.volume_based_fees?.[10]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_11_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 10"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[10]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_10'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_11_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 10"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[10]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[10]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'fee_12'">{{ row.original.bid?.volume_based_fees?.[11]?.name }}</ng-container>
                <ng-container *ngSwitchCase="'fee_12_price'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 11"><span *ngIf="!isConvertedUnits">{{ row.original.bid?.volume_based_fees?.[11]?.price?.price?.value }}</span><span *ngIf="isConvertedUnits">{{ row.original.bid['exchanged_fee_11'] | number: '1.4-4' }}</span></ng-container></ng-container>
                <ng-container *ngSwitchCase="'fee_12_unit'"><ng-container *ngIf="row.original.bid?.volume_based_fees?.length > 11"><span class="text-muted small">{{ isConvertedUnits ? (baseCurrency.code + '/' + baseUnit.code) : (row.original.bid?.volume_based_fees?.[11]?.price?.price?.currency?.code + '/' + row.original.bid?.volume_based_fees?.[11]?.price?.units?.code) }}</span></ng-container></ng-container>

                <ng-container *ngSwitchCase="'total_fees'">
                  {{ row.original.bid['fees_sum'] | number: '1.0-2' }}
                </ng-container>

                <ng-container *ngSwitchCase="'total_fees_unit'">
                  <span class="text-muted small">{{ baseCurrency.code }} / {{ baseUnit.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'gap_vs_prev'">{{ row.original.bid['prev_sum'] | number: '1.0-2' }}</ng-container>
                <ng-container *ngSwitchCase="'gap_vs_prev_unit'">
                  <span class="text-muted small">{{ baseCurrency.code }} / {{ baseUnit.code }}</span>
                </ng-container>

                <ng-container *ngSwitchCase="'gap_total'">{{ row.original.bid['total_prev_sum'] | number: '1.0-0' }}</ng-container>

                <ng-container *ngSwitchCase="'contract_total'">
                  <span *ngIf="row.original.bid['contract_total'] != null">
                    {{ row.original.bid['contract_total'] | number: '1.0-0' }}
                  </span>
                </ng-container>

                <ng-container *ngSwitchCase="'selected'">
                  <input *ngIf="row.original.status !== 'AWARDED_CONTRACT'"
                         type="checkbox"
                         class="form-check-input"
                         [(ngModel)]="row.original['is_included']"
                         [ngModelOptions]="{standalone: true}"
                         [disabled]="!user.canManage(tender)"
                         (ngModelChange)="onIsIncludedToReport($event)"
                         (change)="onIsIncludedToReport2(row.original['is_included'], row.original)">
                </ng-container>

                <ng-container *ngSwitchCase="'award_percentage'">
                  <div *ngIf="row.original.status !== 'AWARDED_CONTRACT'" class="input-group input-group-sm">
                    <input type="text"
                           class="form-control form-control-sm"
                           [ngModelOptions]="{standalone: true}"
                           [(ngModel)]="row.original['input_awarded_percent']"
                           [disabled]="!user.canManage(tender)"
                           (change)="onAwardedPercent($event, row.original.id, row.original['input_awarded_percent'])">
                    <span class="input-group-text">%</span>
                  </div>
                </ng-container>

                <ng-container *ngSwitchCase="'award_gap_total'">{{ row.original.bid['total_prev_sum2'] | number: '1.0-0' }}</ng-container>

                <ng-container *ngSwitchDefault>
                  <ng-container *ngIf="cell.getValue() !== null && cell.getValue() !== undefined && cell.getValue() !== ''">
                    <ng-container *ngIf="isNumeric(cell.getValue()); else rawValue">
                      {{ cell.getValue() | number: '1.0-2' }}
                    </ng-container>
                    <ng-template #rawValue>{{ cell.getValue() }}</ng-template>
                  </ng-container>
                </ng-container>

              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Footer with pagination -->
    <div class="table-footer">
      <div class="footer-meta">
        <span class="text-muted small">
          Showing {{ pageStart }}–{{ pageEnd }} of {{ totalRows }}
        </span>
      </div>
      <div class="footer-pagination">
        <select class="form-select form-select-sm page-size-select"
                [ngModel]="table.getState().pagination.pageSize"
                (ngModelChange)="setPageSize($event)">
          <option *ngFor="let opt of pageSizeOptions" [ngValue]="opt">{{ opt }}/page</option>
        </select>
        <div class="btn-group btn-group-sm" role="group">
          <button type="button" class="btn btn-outline-secondary"
                  [disabled]="!table.getCanPreviousPage()"
                  (click)="prevPage()">
            <i class="fas fa-chevron-left"></i>
          </button>
          <button type="button" class="btn btn-outline-secondary disabled-look">
            Page {{ table.getState().pagination.pageIndex + 1 }} / {{ table.getPageCount() }}
          </button>
          <button type="button" class="btn btn-outline-secondary"
                  [disabled]="!table.getCanNextPage()"
                  (click)="nextPage()">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
